import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: flex;
    background-color: ${COLORS.white};
    border-radius: 25px;
    max-width: 854px;
    flex-wrap: nowrap;
    z-index: 1;
    position: relative;
    top: ${props => -props.top}px;
    align-self: ${props => props.alignSelf};
    @media screen and (max-width: 1330px){
        align-self: flex-start;
    }
    @media screen and (max-width: 560px){
        flex-direction: column;
    }
`;

export const WrappContent = styled.div`
    display: flex;
    background-color: ${COLORS.white};
    flex-direction: column;
    margin: 76px 50px 71px 45px;
    @media screen and (max-width: 990px){
        margin: 51px 5px 52px 24px;
    }
`;

export const Image = styled.img`
    width: 250px;
    height: 205px;
    margin: 39px 0 41px 50px;
    @media screen and (max-width: 990px){
        width: 225px;
        height: 185px;
        margin: 39px 0 0 14px;
    }
`;

export const Title = styled.div`
    ${FONTS.H4};
    margin-top: 10px;
`;

export const Text = styled.div`
    ${FONTS.S};
    margin-top: 14px;
`;

export const StepNumber = styled.div`
    ${FONTS.H4};
`;
